var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackImageGenerate = function SvgBackImageGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.167 4.167h5c1.378 0 2.5 1.121 2.5 2.5 0 1.378-1.122 2.5-2.5 2.5h-2.5v1.666h2.5a4.17 4.17 0 0 0 4.166-4.166A4.17 4.17 0 0 0 9.167 2.5h-5V0L0 3.333l4.167 3.334z"
  })));
};
export default SvgBackImageGenerate;